import { useState, useEffect } from 'react'

/**
 * Hook to detect when the document visibility state changes
 * (e.g., when a user switches tabs or minimizes the window)
 *
 * @returns {Object} visibility state and change count
 */
export function useDocumentVisibility() {
  const [isVisible, setIsVisible] = useState(!document.hidden)
  const [visibilityChangeCount, setVisibilityChangeCount] = useState(0)

  useEffect(() => {
    const handleVisibilityChange = () => {
      const visible = !document.hidden
      setIsVisible(visible)

      // If switching from visible to hidden, increment the count
      if (!visible) {
        setVisibilityChangeCount((prev) => prev + 1)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return { isVisible, visibilityChangeCount }
}
